import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MessagesService } from '../../components/messages/messages.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly messages: MessagesService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          // Skip auth-related errors; AuthInterceptor handles logout/redirect
          if (error.status !== 401 && error.status !== 403) {
            const message = this.buildMessage(error);
            if (message) {
              this.messages.showError(message, 8000);
            }
          }
        }
        return throwError(() => error);
      })
    );
  }

  private buildMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Network error: Unable to reach the server.';
    }

    // Prefer server-provided error messages if available
    const data = error.error as any;
    const candidates: Array<string | undefined> = [
      data?.message,
      data?.error?.message,
      data?.title,
      typeof data === 'string' ? data : undefined,
      error.statusText,
    ];

    const msg = candidates.find((m) => !!m)?.toString()?.trim();
    if (msg) {
      return `${error.status} ${this.statusLabel(error.status)}: ${msg}`;
    }
    return `Request failed with status ${error.status} ${this.statusLabel(error.status)}.`;
  }

  private statusLabel(status: number): string {
    switch (status) {
      case 400: return 'Bad Request';
      case 404: return 'Not Found';
      case 409: return 'Conflict';
      case 422: return 'Unprocessable Entity';
      case 500: return 'Server Error';
      case 503: return 'Service Unavailable';
      default: return '';
    }
  }
}
